<template>
    <ul class="af-payband-nav afu-flex afu-items-center afu-text-sm afu-list-none afu-m-0 afu-p-0">
        <li
            v-for="pay in payTypeMenu"
            :key="pay"
            class="af-payband-nav-item afu-m-1"
            :class="{ 'is-active': pay === value }"
        >
            <a
                href=""
                :class="{ 'afu-text-primary-400 afu-font-semibold': pay === value, 'afu-text-gray-600': pay !== value }"
                class="af-payband-nav-link hover:afu-no-underline"
                @click.stop.prevent="!disabled && select(pay)"
            >
                {{ pay }}
            </a>
        </li>
    </ul>
</template>

<script>
    const payType = ['Annually', 'Hourly'];

    export default {
        name: 'PayBandMenu',

        props: {
            value: {
                type: String,
                required: true,
            },

            variant: {
                type: String,
                default: 'primary',
                validator: value => ['primary', 'success'].includes(value),
            },

            hide: {
                type: String,
                default: '',
                validator: value => {
                    if (value) {
                        return payType.includes(value);
                    } else {
                        return true;
                    }
                },
            },

            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {};
        },

        computed: {
            classList() {
                return ['pay-band-menu', this.getVariantClass];
            },

            getVariantClass() {
                return this.variant ? `pay-band-menu--${this.variant}` : '';
            },

            payTypeMenu() {
                return payType.filter(o => this.hide !== o);
            },
        },

        watch: {
            hideAnnually() {
                this.$emit('input', 'Hourly');
            },
        },

        methods: {
            select(item) {
                this.$emit('input', item);
            },
        },
    };
</script>
